import Button from '../button';
import Checklist from '../check-list';
import Link from '../link';
import List from '../list';
import Paragraph from '../paragraph';
import Video from '../video';

const RenderContent = ( { items } ) => {
	return items?.map( ( item, index ) => {
		switch ( item.type ) {
			case 'video':
				return (
					<Video
						key={ index }
						url={ item.data.url }
						title={ item.data.title }
					/>
				);
			case 'image':
				return (
					<img
						key={ index }
						src={ item.data.src }
						alt={ item.data.alt || '' }
						className="w-full h-auto shadow-sm rounded-lg border-0.5 border-solid border-border-subtle"
					/>
				);
			case 'link':
				return (
					<Link
						key={ index }
						prefix={ item.prefix }
						text={ item.data.text }
						url={ item.data.url }
						target={ item.data.target }
					/>
				);
			case 'heading':
				return <Paragraph key={ index } text={ item.text } isHeading />;
			case 'paragraph':
			case 'text':
				return <Paragraph key={ index } text={ item.text } />;
			case 'list':
				return <List key={ index } items={ item.data.items } />;
			case 'checklist':
				return <Checklist key={ index } items={ item.data.items } />;
			case 'button':
				return (
					<Button
						key={ index }
						onClick={ () =>
							window.open( item.data.url, item.data.target )
						}
						{ ...item.data }
					/>
				);
			default:
				return null;
		}
	} );
};

export default RenderContent;
